import { get_token as get_router_token } from "@/router";

export const product_promo_utility_methods = {
  get_token() {
    return get_router_token();
  },
  open_product_promo_code_manager_modal(product_payload = null) {
    const product = product_payload?.product || product_payload;
    const base_profile_id = product_payload?.base_profile_id || null;

    if (product?.id) {
      this.selected_product = product;
      this.selected_product_id = String(product.id);
    }
    this.is_catalogue_promo = false;
    this.selected_products = [];
    this.catalogue_base_profile_id = null;
    this.selected_base_profile_id = base_profile_id;
    this.return_to_promo_manager = false;
    $("#product_promo_code_manager_modal").modal("show");
    this.get_product_promo_codes();
  },
  open_catalogue_promo_code_manager_modal({ products = [], base_profile_id = null } = {}) {
    this.reset_form();
    this.selected_product = null;
    this.selected_product_id = "";
    this.selected_base_profile_id = null;
    this.selected_products = products;
    this.catalogue_base_profile_id = base_profile_id;
    this.is_catalogue_promo = true;
    this.return_to_promo_manager = false;
    this.return_to_catalogue_promo_manager = false;
    $("#catalogue_promo_code_manager_modal").modal("show");
    this.get_catalogue_promo_codes();
  },
  open_catalogue_promo_code_form_modal({ products = null, base_profile_id = null } = {}) {
    const catalogue_products = products || this.selected_products;
    const catalogue_base_profile_id = base_profile_id || this.catalogue_base_profile_id;
    this.reset_form();
    this.selected_product = null;
    this.selected_product_id = "";
    this.selected_base_profile_id = null;
    this.selected_products = catalogue_products;
    this.catalogue_base_profile_id = catalogue_base_profile_id;
    this.is_catalogue_promo = true;
    this.return_to_promo_manager = false;
    this.return_to_catalogue_promo_manager = true;
    this.swap_modals("#catalogue_promo_code_manager_modal", "#product_promo_code_form_modal");
  },
  close_child_modal() {
    const return_to_catalogue = this.return_to_catalogue_promo_manager;
    const return_to_product = this.return_to_promo_manager;

    this.reset_form();
    this.return_to_catalogue_promo_manager = false;
    this.return_to_promo_manager = false;

    setTimeout(() => {
      if (return_to_catalogue) {
        $("#catalogue_promo_code_manager_modal").modal("show");
        return;
      }

      if (return_to_product) {
        $("#product_promo_code_manager_modal").modal("show");
      }
    }, 250);
  },
  open_child_modal() {
    this.return_to_promo_manager = true;
    this.swap_modals("#product_promo_code_manager_modal", "#product_promo_code_form_modal");
  },
  swap_modals(current_modal_id, next_modal_id) {
    const current_modal = $(current_modal_id);

    current_modal.one("hidden.bs.modal", () => {
      $(next_modal_id).modal("show");
    });
    current_modal.modal("hide");
  },
  reset_form() {
    this.promo_code_name = "";
    this.discount_type = this.discount_types?.[0]?.id ?? "";
    this.discount_value = 0;
    this.start_date = null;
    this.end_date = null;
    this.usage_limit = 0;
    this.minimum_order_amount = 0;
    this.is_active = true;
    this.promo_errors = {};
    this.is_editing_product_promo = false;
    this.is_catalogue_promo = false;
    this.editing_product_promo_code_id = null;
  },
  get_date_time_local_string(date = new Date()) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  },
  format_date(date_string) {
    if (!date_string) return "";
    const date = new Date(date_string);
    if (isNaN(date)) return "";
    return date.toLocaleDateString();
  },
  format_amount(amount) {
    return Number(amount || 0).toLocaleString("en-ZA", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  },
  get_promo_code_name(product_promo) {
    return (
      product_promo?.promo_code_name ||
      product_promo?.promo_code?.promo_code_name ||
      product_promo?.promo_code?.name ||
      product_promo?.code ||
      "-"
    );
  },
  get_promo_code_discount_id(product_promo) {
    return product_promo?.promo_code_discount_id || product_promo?.product_promo_code_id || product_promo?.id || null;
  },
  open_product_promo_form_modal() {
    this.reset_form();
    this.open_child_modal();
  },
  open_edit_product_promo_form_modal(product_promo) {
    this.reset_form();
    this.is_editing_product_promo = true;
    this.editing_product_promo_code_id = this.get_promo_code_discount_id(product_promo);
    this.apply_product_promo_to_form(product_promo);
    this.open_child_modal();
  },
  open_edit_catalogue_promo_form_modal(product_promo) {
    const catalogue_products = this.selected_products;
    const catalogue_base_profile_id = this.catalogue_base_profile_id;
    this.reset_form();
    this.selected_product = null;
    this.selected_product_id = "";
    this.selected_products = catalogue_products;
    this.catalogue_base_profile_id = catalogue_base_profile_id;
    this.is_catalogue_promo = true;
    this.is_editing_product_promo = true;
    this.editing_product_promo_code_id = this.get_promo_code_discount_id(product_promo);
    this.apply_product_promo_to_form(product_promo);
    this.return_to_catalogue_promo_manager = true;
    this.swap_modals("#catalogue_promo_code_manager_modal", "#product_promo_code_form_modal");
  },
  apply_product_promo_to_form(product_promo) {
    this.promo_code_name = this.get_promo_code_name(product_promo) === "-" ? "" : this.get_promo_code_name(product_promo);
    this.discount_type = product_promo?.promo_code?.promo_code_type?.id ?? this.discount_type;
    this.discount_value = product_promo?.promo_code?.discount_amount ?? this.discount_value;
    this.start_date = product_promo?.valid_start_date
      ? this.get_date_time_local_string(new Date(product_promo.valid_start_date))
      : null;
    this.end_date = product_promo?.valid_end_date
      ? this.get_date_time_local_string(new Date(product_promo.valid_end_date))
      : null;
    this.usage_limit = product_promo?.has_usage_limit ? Number(product_promo?.usage_limit ?? 0) : 0;
    this.minimum_order_amount = Number(product_promo?.minimum_order_amount ?? 0);
    this.is_active = !!product_promo?.is_active;
  },
  validate_promo_code_form() {
    const start_timestamp = new Date(this.start_date).getTime();
    const end_timestamp = new Date(this.end_date).getTime();
    const base_profile_id = this.get_selected_base_profile_id();
    let is_valid = true;
    this.promo_errors = {};

    if (!this.is_catalogue_promo && !this.selected_product_id) {
      this.promo_errors.product = "Product is required.";
      is_valid = false;
    }
    if (this.is_catalogue_promo && !this.selected_products.length) {
      this.promo_errors.product = "Catalogue products are required.";
      is_valid = false;
    }
    if (!base_profile_id) {
      this.promo_errors.product = "Product vendor is required.";
      is_valid = false;
    }
    if (this.start_date && this.end_date && end_timestamp <= start_timestamp) {
      this.promo_errors.end_date = "End date must be greater than the start date.";
      is_valid = false;
    }

    const percentage_type = this.discount_types.find(
      (type) => String(type.name || type.label).toLowerCase() === "percentage",
    );
    const value = parseFloat(this.discount_value);
    const minimum_order_amount = parseFloat(this.minimum_order_amount || 0);

    if (!this.discount_type) {
      this.promo_errors.discount_type = "Discount type is required.";
      is_valid = false;
    }
    if (this.discount_value === "" || isNaN(value) || value <= 0) {
      this.promo_errors.discount_value = "Discount value must be greater than 0.";
      is_valid = false;
    }
    if (isNaN(minimum_order_amount) || minimum_order_amount < 0) {
      this.promo_errors.minimum_order_amount = "Minimum order amount cannot be less than 0.";
      is_valid = false;
    }
    if (percentage_type && String(this.discount_type) === String(percentage_type.id) && value > 100) {
      this.promo_errors.discount_value = "Percentage cannot exceed 100%.";
      is_valid = false;
    }

    return is_valid;
  },
  build_payload(extra = {}) {
    const base_profile_id = this.get_selected_base_profile_id();
    const product_id = this.selected_product_id ? Number(this.selected_product_id) : undefined;
    const promo_code_name = String(this.promo_code_name || "").trim();

    return ({
      base_profile_id,
      ...(product_id ? { product_id } : {}),
      ...(promo_code_name ? { promo_code_name } : {}),
      valid_start_date: this.start_date || null,
      valid_end_date: this.end_date || null,
      usage_limit: String(this.usage_limit || 0),
      minimum_order_amount: this.minimum_order_amount || 0,
      is_active: this.is_active,
      has_usage_limit: Number(this.usage_limit || 0) > 0,
      promo_code_type_id: this.discount_type,
      discount_amount: this.discount_value,
      ...extra,
    });
  },
  get_selected_base_profile_id() {
    return (
      this.catalogue_base_profile_id ||
      this.selected_base_profile_id ||
      this.selected_product?.base_profile?.company?.base_profile?.id ||
      this.selected_product?.base_profile?.id ||
      this.selected_product?.base_profile_id
    );
  },
  submit_form() {
    if (this.is_editing_product_promo) {
      this.update_product_promo_code();
    } else if (this.is_catalogue_promo) {
      this.create_catalogue_product_promo_codes();
    } else {
      this.create_product_promo_code();
    }
  },
};
